import React, { useEffect, useState } from 'react';
import './newdonation.css';
import Carousel from 'react-elastic-carousel';
import Image1 from '../NewDonation/NewDonationImages/Rectangle 9.png';
import Image2 from '../NewDonation/NewDonationImages/Rectangle 10.png';
import Uang from '../Cards/CardsImages/uang.png';
import Pakaian from '../Cards/CardsImages/pakaian.png';
import Makanan from '../Cards/CardsImages/makanan.png';
import Progress from '../NewDonation/Progress Bar/progressbar'
import axios from 'axios';



export default function Carousel2() {
    const [card1, setCard1] = useState([])

    const fetchCard1 = async () => {
        const { data } = await axios.get(
            'https://weshare-heroku.herokuapp.com/api/weShare/category/newest'
        )
        setCard1(data.data)
        console.log(data.data)
    }

    useEffect(() => {
        fetchCard1()
    }, [])

    const breakPoints = [
        { width: 1, itemsToShow: 1 },
        { width: 500, itemsToShow: 1 },
        { width: 768, itemsToShow: 2 },
        { width: 1200, itemsToShow: 2 },
    ];
    return (
        // <div className="carousel1" breakPoints={breakPoints} >
        <Carousel breakPoints={breakPoints}>
            {card1.map(c => (
                <div className="card-donation">
                    <div className="newdonation-card-wrapper" key={c.id}>
                        <div className="newdonation-card-column">
                            <img src={c.image} alt="" width="580" height="184" />
                            <h5 className="newdonation-title-1">{c.donationName}</h5>
                            <Progress done="60" />
                            <h6 className="newdonation-h6"><span className="bold-style">{c.donationNeeded}</span> Orang berdonasi</h6>
                        </div>
                        <div className="newdonation-card-row">
                            <div className="border-solid">
                                <img className="icon" src={Uang} alt="" width="70" height="70" />
                                <p className="icon-txt-donation"><span className="bold-style">{c.donationNeeded}</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </Carousel>
        // </div>
    )
}
